import React, { useEffect, useMemo, useReducer, useRef, useState } from 'react';
import './NotificationCreate.scss';
import moment from 'moment';
import {
  Button,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  Tooltip,
  Checkbox,
} from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import {
  NOTIFICATIONS_TYPE,
  NOTIFICATION_CREATE,
  NOTIFICATION_DEVICE,
  VALID_DATE_ERROR_MESSAGE,
} from '../../../../constants/NotificationsConst';
import ImageUpload from '../../../../shared/image-upload/ImageUpload';
import { formDataValidate, handleValidation } from '../../../../utils/formUtils';
import InfoIcon from '@mui/icons-material/Info';
import {
  KeyboardDatePicker,
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import CustomMultiSelect from '../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import { getProcessedImages } from '../../../../shared/image-upload/ImageProcessor';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { useDispatch, useSelector } from 'react-redux';
import {
  allFloorsSelector,
  allHotelsSelector,
  allRoomsSelector,
  allRoomTypesSelector,
  fetchAllAccommodations,
} from '../../../property/propertySlice';
import { fetchAllNotifications } from '../../../services/servicesSlice';
import { createNotifications, updateNotifications } from '../../../../utils/ServicesAPIUtils';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';
import ReactQuill from 'react-quill-new';
import 'quill/dist/quill.snow.css';
import UndoIcon from '@material-ui/icons/Undo';
import RedoIcon from '@material-ui/icons/Redo';
import WrapTextIcon from '@mui/icons-material/WrapText';
import {
  decodeMediaKeyValue,
  renderVideos,
  renderGifs,
  toMediaContent,
  processGifsForUpload,
} from '../../../../utils/mediaUtils';

const toPlainText = (html = '') => {
  if (!html) return '';
  const textarea = document.createElement('textarea');
  textarea.innerHTML = html;
  const decoded = textarea.value;
  return decoded
    ?.replace(/<br\s*\/?>/gi, '\n')
    ?.replace(/<\/li>/gi, '\n')
    ?.replace(/<(?:.|\n)*?>/g, '')
    ?.replace(/\u00A0/g, ' ')
    ?.replace(/&nbsp;/gi, ' ')
    ?.trim();
};
const QuillToolbar = () => (
  <div id='notif-quill-toolbar' className='rta-toolbar ql-toolbar ql-snow'>
    <span className='ql-formats'>
      <button className='ql-undo' type='button' aria-label='Undo'>
        <UndoIcon fontSize='small' />
      </button>
      <button className='ql-redo' type='button' aria-label='Redo'>
        <RedoIcon fontSize='small' />
      </button>
    </span>
    <span className='ql-formats'>
      <button className='ql-bold' type='button' />
      <button className='ql-italic' type='button' />
      <button className='ql-underline' type='button' />
    </span>
    <span className='ql-formats'>
      <button className='ql-list' value='bullet' type='button' />
    </span>
    <span className='ql-formats'>
      <button className='ql-linebreak' type='button' aria-label='Line break'>
        <WrapTextIcon fontSize='small' />
      </button>
    </span>
  </div>
);

const NotificationCreate = (props) => {
  const { toggleDrawer, obj, hotelId, editing, showLoader = () => {} } = props;
  const [tabValue, setTabValue] = useState(0);
  const [rawImages, setRawImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isTabInValid, setIsTabInValid] = useState(false);
  const [daysError, setDaysError] = useState(false);
  const originalHotels = useSelector(allHotelsSelector);
  const originalRoomList = useSelector(allRoomsSelector);
  const originalFloorList = useSelector(allFloorsSelector);
  const originalRoomTypeList = useSelector(allRoomTypesSelector);
  const [floorOptions, setFloorOptions] = useState([]);
  const [floorSearchValue, setFloorSearchValue] = useState('');
  const [roomTypeOptions, setRoomTypeOptions] = useState([]);
  const [roomTypeSearchValue, setRoomTypeSearchValue] = useState('');
  const [roomOptions, setRoomOptions] = useState([]);
  const [roomSearchValue, setRoomSearchValue] = useState([]);
  const dispatch = useDispatch();
  const quillRef = useRef(null);
  const MESSAGE_MAX = Number(process.env.REACT_APP_PUSH_MSG_MAX || 1000);
  const [messageHtml, setMessageHtml] = useState('');
  const [msgCount, setMsgCount] = useState(0);
  const draftKey = useMemo(() => `notif_msg_draft_${hotelId}`, [hotelId]);
  const trimmingRef = useRef(false);

  const [rawVideos, setRawVideos] = useState([]);
  const [rawGifs, setRawGifs] = useState([]);
  const [videoImageUrl, setVideoImageUrl] = useState('');
  const [gifImageUrl, setGifImageUrl] = useState('');
  const [hasVideoError, setHasVideoError] = useState(false);
  const [isThumbnailUploading, setIsThumbnailUploading] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [isGifLoading, setIsGifLoading] = useState(false);
  const groupId = originalHotels?.find((h) => h?.id === hotelId)?.groupId;

  const getQuill = () =>
    quillRef.current && quillRef.current.getEditor ? quillRef.current.getEditor() : null;
  const clampToMax = () => {
    const quill = getQuill();
    if (!quill) return false;
    const lengthWithoutTrailing = Math.max(0, quill.getLength() - 1);
    if (lengthWithoutTrailing <= MESSAGE_MAX) return false;
    const selection = quill?.getSelection();
    quill?.deleteText(MESSAGE_MAX, lengthWithoutTrailing - MESSAGE_MAX, 'silent');
    if (selection) {
      quill?.setSelection(Math?.min(selection?.index, MESSAGE_MAX), selection?.length, 'silent');
    }
    return true;
  };

  const syncStateFromQuill = () => {
    const quill = getQuill();
    const plain = (quill?.getText() || '').replace(/\n$/, '');
    setMessageHtml(quill?.root?.innerHTML || '');
    setMsgCount(plain.length);
    const updated = {
      ...formData.message,
      value: plain,
      errors: { ...(formData.message.errors || {}) },
    };
    handleValidation(updated);
    setFormData({ message: updated });
  };

  const onQuillChange = (content, delta, source) => {
    if (trimmingRef.current) {
      trimmingRef.current = false;
      syncStateFromQuill();
      return;
    }
    if (source === 'user' && clampToMax()) {
      syncStateFromQuill();
      return;
    }
    const quill = getQuill();
    const plain = (quill?.getText() || '').replace(/\n$/, '');
    setMessageHtml(content);
    setMsgCount(plain.length);

    const updated = {
      ...formData.message,
      value: plain,
      errors: { ...(formData.message.errors || {}) },
    };
    handleValidation(updated);
    setFormData({ message: updated });
  };

  const onCancel = (e) => {
    try {
      localStorage.removeItem(draftKey);
    } catch {}
    resetMessageEditor();
    toggleDrawer('', false, '');
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else {
      if (validate(tabValue)) {
        if (tabValue === 1 && isTabInValid) {
          return;
        } else {
          setTabValue(newValue);
        }
      }
    }
  };

  const onNextClick = () => {
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    type: {
      value: '',
      fieldName: 'Type',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    title: {
      value: '',
      fieldName: 'Title',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    message: {
      value: '',
      fieldName: 'Notification Message',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    devices: {
      value: '',
      fieldName: 'Select Device',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    recipient: {
      value: 'Both',
      fieldName: 'Recipient',
      errors: {},
      validations: [],
      tab: 0,
    },
    residentFloor: {
      value: [],
      fieldName: 'Select Floor(s)',
      errors: {},
      validations: [],
      tab: 0,
    },
    residentRoomType: {
      value: [],
      fieldName: 'Select Room type(s)',
      errors: {},
      validations: [],
      tab: 0,
    },
    residentRoom: {
      value: [],
      fieldName: 'Select Room(s)',
      errors: {},
      validations: [],
      tab: 0,
    },
    schedule: {
      value: 'Instant',
      fieldName: 'Schedule',
      errors: {},
      validations: [],
      tab: 1,
    },
    date: {
      value: moment().format('DD-MM-YYYY'),
      fieldName: 'Date',
      errors: {},
      validations: ['required', 'validDate'],
      tab: 1,
    },
    oneTime: {
      value: moment().format('HH:mm'),
      fieldName: 'Time',
      errors: {},
      validations: [],
      tab: 1,
    },
    from: {
      value: '',
      fieldName: 'From',
      errors: {},
      validations: [],
      tab: 1,
    },
    to: {
      value: '',
      fieldName: 'To',
      errors: {},
      validations: [],
      tab: 1,
    },
    everyday: {
      value: 'EveryDay',
      fieldName: 'Everyday',
      errors: {},
      validations: [],
      tab: 1,
    },
    days: {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
      value: [],
      fieldName: 'days',
      validations: [],
      tab: 1,
    },
    impressions: {
      value: '',
      fieldName: 'No. of Impressions per day',
      errors: {},
      validations: ['required', 'positiveOnly'],
      tab: 1,
    },
    time: {
      value: '',
      fieldName: 'Time',
      errors: {},
      validations: [],
      tab: 1,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 2,
    },
  });
  const weekDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  const [allowedDays, setAllowedDays] = useState(new Set(weekDays));
  const [editorKey, setEditorKey] = useState(0);
  const resetMessageEditor = () => {
    const quill = getQuill();
    if (quill) {
      quill?.setText('', 'silent');
      quill?.history?.clear?.();
      quill?.setSelection(0, 0, 'silent');
    }
    setMessageHtml('');
    setMsgCount(0);
    setFormData({ message: { ...formData.message, value: '' } });
    setEditorKey((k) => k + 1);
    try {
      localStorage?.removeItem(draftKey);
    } catch {}
  };

  useEffect(() => {
    if (tabValue !== 0) return;
    const savedDraft = !editing ? localStorage.getItem(draftKey) : null;
    const initialText = editing && obj ? obj?.message || '' : formData?.message?.value || '';
    const html = savedDraft && toPlainText(savedDraft)?.length ? savedDraft : initialText;
    setMessageHtml(html);
    const text = toPlainText(html);
    setMsgCount(Math?.min(text.length, MESSAGE_MAX));
    setFormData({ message: { ...formData.message, value: text.slice(0, MESSAGE_MAX) } });
  }, [tabValue, editing, obj, draftKey, MESSAGE_MAX]);

  useEffect(() => {
    if (editing) return;
    const id = setTimeout(() => {
      if (messageHtml && toPlainText(messageHtml)?.length) {
        try {
          localStorage?.setItem(draftKey, messageHtml);
        } catch {}
      } else {
        try {
          localStorage?.removeItem(draftKey);
        } catch {}
      }
    }, 400);
    return () => clearTimeout(id);
  }, [messageHtml, draftKey, editing]);

  const quillModules = useMemo(() => {
    const ensureRange = () => {
      const quill = quillRef?.current?.getEditor();
      if (!quill) return null;
      let range = quill?.getSelection();
      if (!range) {
        quill?.focus();
        const index = quill?.getLength();
        quill?.setSelection(index, 0);
        range = { index, length: 0 };
      }
      return { quill, range };
    };

    return {
      toolbar: {
        container: '#notif-quill-toolbar',
        handlers: {
          undo: () => quillRef.current?.getEditor()?.history?.undo(),
          redo: () => quillRef.current?.getEditor()?.history?.redo(),
          list: function (value) {
            const ctx = ensureRange();
            if (!ctx) return;
            const { quill, range } = ctx;
            const formats = quill.getFormat(range);
            const next = formats.list === value ? false : value;
            quill.format('list', next);
          },
          linebreak: () => {
            const ctx = ensureRange();
            if (!ctx) return;
            const { quill, range } = ctx;
            const lengthWithoutTrailing = Math.max(0, quill.getLength() - 1);
            if (lengthWithoutTrailing >= MESSAGE_MAX) return;
            quill.deleteText(range.index, range.length, 'user');
            quill.insertText(range.index, '\n', 'user');
            quill.setSelection(range.index + 1, 0, 'silent');
          },
        },
      },
      history: { delay: 500, maxStack: 100, userOnly: true },
      clipboard: { matchVisual: false },
    };
  }, [MESSAGE_MAX]);

  const quillFormats = ['bold', 'italic', 'underline', 'list'];

  useEffect(() => {
    if (formData?.recipient?.value === 'Resident') {
      dispatch(fetchAllAccommodations(hotelId));
    }
  }, [formData?.recipient?.value, hotelId, dispatch]);

  useEffect(() => {
    if (formData?.schedule?.value !== 'Repeat') {
      setAllowedDays(new Set(weekDays));
      return;
    }
    const { from, to } = formData;
    if (!from?.value || !to?.value) return;
    const start = moment(from?.value, 'DD-MM-YYYY');
    const end = moment(to?.value, 'DD-MM-YYYY');
    if (!start?.isValid() || !end?.isValid() || end?.isBefore(start)) return;
    const daysInRange = new Set();
    for (let d = start?.clone(); !d?.isAfter(end); d?.add(1, 'day')) {
      daysInRange?.add(d?.format('dddd')?.toLowerCase());
      if (daysInRange?.size === 7) break;
    }
    setAllowedDays(daysInRange);
    const updatedDays = { ...formData.days };
    updatedDays.value = updatedDays?.value?.filter((day) => daysInRange?.has(day?.toLowerCase()));
    weekDays.forEach((wd) => {
      updatedDays[wd] = updatedDays?.value?.includes(wd?.toUpperCase());
    });
    setFormData({ days: updatedDays });
  }, [formData?.from?.value, formData?.to?.value, formData?.schedule?.value]);

  useEffect(() => {
    setFloorOptions(originalFloorList);
  }, [originalFloorList]);

  useEffect(() => {
    setRoomTypeOptions(originalRoomTypeList);
  }, [originalRoomTypeList]);

  useEffect(() => {
    setRoomOptions(originalRoomList);
  }, [originalRoomList]);

  const onSearchFloorList = (search) => {
    setFloorSearchValue(search);
    if (!search) return setFloorOptions(originalFloorList);
    setFloorOptions(
      originalFloorList?.filter((f) => f?.name?.toLowerCase()?.includes(search?.toLowerCase())),
    );
  };
  const useQuillMaxLengthGuards = (getQuill, MESSAGE_MAX) => {
    React?.useEffect(() => {
      const quill = getQuill?.();
      if (!quill) return;
      const root = quill.root;
      const getPlainLen = () => Math.max(0, quill.getLength() - 1);
      const onBeforeInput = (e) => {
        const insertTypes = new Set([
          'insertText',
          'insertLineBreak',
          'insertParagraph',
          'insertReplacementText',
          'insertFromDrop',
          'insertFromPaste',
        ]);
        if (!insertTypes.has(e.inputType)) return;
        const range = quill?.getSelection();
        const selectionLength = range ? range.length : 0;
        if (getPlainLen() - selectionLength >= MESSAGE_MAX) {
          e.preventDefault();
        }
      };
      const onPaste = (e) => {
        const range = quill?.getSelection() || { index: quill?.getLength(), length: 0 };
        const selectionLength = range?.length || 0;
        const len = getPlainLen();
        const remaining = MESSAGE_MAX - (len - selectionLength);
        if (remaining <= 0) {
          e.preventDefault();
          return;
        }
        const text = (e?.clipboardData || window?.clipboardData)?.getData('text/plain') ?? '';
        if (!text) return;
        if (text.length > remaining) {
          e?.preventDefault();
          if (selectionLength > 0) {
            quill?.deleteText(range?.index, selectionLength, 'user');
          }
          quill?.insertText(range?.index, text?.slice(0, remaining), 'user');
          quill?.setSelection(range?.index + remaining, 0, 'silent');
        }
      };
      const onTextChange = (delta, oldDelta, source) => {
        if (source !== 'user') return;
        const currentLen = getPlainLen();
        if (currentLen > MESSAGE_MAX) {
          const selection = quill?.getSelection();
          quill?.deleteText(MESSAGE_MAX, currentLen - MESSAGE_MAX, 'silent');
          if (selection) {
            quill?.setSelection(Math?.min(selection.index, MESSAGE_MAX), selection?.length, 'silent');
          }
        }
      };
      root?.addEventListener('beforeinput', onBeforeInput);
      root?.addEventListener('paste', onPaste);
      quill.on('text-change', onTextChange);
      return () => {
        root?.removeEventListener('beforeinput', onBeforeInput);
        root?.removeEventListener('paste', onPaste);
        quill?.off('text-change', onTextChange);
      };
    }, [getQuill, MESSAGE_MAX]);
  };
  useQuillMaxLengthGuards(getQuill, MESSAGE_MAX);
  useEffect(() => {
    return () => {
      if (!editing) {
        try {
          localStorage?.removeItem(draftKey);
        } catch {}
      }
    };
  }, [editing, draftKey]);

  const onSearchRoomTypeList = (search) => {
    setRoomTypeSearchValue(search);
    if (!search) return setRoomTypeOptions(originalRoomTypeList);
    setRoomTypeOptions(
      originalRoomTypeList?.filter((rt) =>
        rt?.name?.toLowerCase()?.includes(search?.toLowerCase()),
      ),
    );
  };

  const onSearchRoomList = (search) => {
    setRoomSearchValue(search);
    if (!search) return setRoomOptions(originalRoomList);
    setRoomOptions(
      originalRoomList?.filter((r) => r?.number?.toLowerCase()?.includes(search?.toLowerCase())),
    );
  };

  const onDaysCheckChange = (e, item) => {
    if (!allowedDays?.has(item)) return;
    const currFields = { ...formData };
    currFields.days[item] = e.target.checked;
    currFields.days[item]
      ? currFields.days.value.push(item.toUpperCase())
      : (currFields.days.value = currFields.days.value.filter(
          (elem) => elem.toLowerCase() !== item,
        ));
    if (currFields.days.value.length > 0) setDaysError(false);
    setFormData(currFields);
  };

  useEffect(() => {
    if (tabValue === 1 && formData.schedule.value === 'Repeat') {
      if (formData.everyday.value === 'Custom' && formData.days.value.length === 0) {
        setIsTabInValid(true);
        return;
      }
      if (validateTillFromDate()) {
        setIsTabInValid(true);
        return;
      }
    }

    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid);
  }, [formData, tabValue]);

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData.images];
    images.splice(index, 1);
    setFormData({ images });
  };

  const validate = (tabValue) => {
    if (
      tabValue === 1 &&
      formData.schedule.value === 'Repeat' &&
      formData.everyday.value === 'Custom' &&
      formData.days.value.length === 0
    ) {
      setDaysError(true);
      return;
    }
    const updatedFields = {};
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    setDaysError(false);
    return isValid;
  };

  const onChangeScheduleStatus = (e) => {
    const currField = { ...formData.schedule };
    currField.value = e.target.value;
    setFormData({ schedule: currField });
  };

  useEffect(() => {
    const currField = { ...formData };
    if (currField.schedule.value === 'Instant') {
      currField.from.validations = [];
      currField.from.value = '';
      currField.to.validations = [];
      currField.to.value = '';
      currField.time.validations = [];
      currField.time.value = '';
      currField.date.validations = [];
      currField.date.value = '';
      currField.oneTime.validations = [];
      currField.oneTime.value = '';
      currField.impressions.validations = [];
      currField.impressions.value = '';
    } else if (currField.schedule.value === 'One-time') {
      currField.from.validations = [];
      currField.from.value = '';
      currField.to.validations = [];
      currField.to.value = '';
      currField.time.validations = [];
      currField.time.value = '';
      currField.date.validations = ['required', 'validDate'];
      currField.date.value = obj?.offerSchedule?.oneTimeSchedule?.date
        ? obj?.offerSchedule?.oneTimeSchedule?.date
        : moment().format('DD-MM-YYYY');
      currField.oneTime.value = obj?.offerSchedule?.oneTimeSchedule?.time
        ? obj?.offerSchedule?.oneTimeSchedule?.time
        : moment().format('HH:mm');
      currField.oneTime.validations = ['validTime'];
      currField.impressions.validations = ['required', 'positiveOnly'];
      if (!Number.isInteger(currField.impressions.value) || currField.impressions.value < 1) {
        currField.impressions.value = '';
      }
    } else {
      currField.from.validations = ['required', 'validDate'];
      currField.from.value = obj?.offerSchedule?.repeatSchedule?.from
        ? obj?.offerSchedule?.repeatSchedule?.from
        : moment().format('DD-MM-YYYY');
      currField.to.validations = ['required', 'validDate'];
      currField.to.value = obj?.offerSchedule?.repeatSchedule?.from
        ? obj?.offerSchedule?.repeatSchedule?.to
        : moment().format('DD-MM-YYYY');
      currField.time.validations = ['required', 'validTime'];
      currField.time.value = obj?.offerSchedule?.repeatSchedule?.time
        ? obj?.offerSchedule?.repeatSchedule?.time
        : moment().format('HH:mm');
      currField.date.validations = [];
      currField.date.value = '';
      currField.oneTime.value = '';
      currField.oneTime.validations = [];
      currField.impressions.validations = ['required', 'positiveOnly'];
      if (!Number.isInteger(currField.impressions.value) || currField.impressions.value < 1) {
        currField.impressions.value = '';
      }
    }
    setFormData(currField);
  }, [formData.schedule.value, obj]);

  useEffect(() => {
    if (obj) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = obj[field];
      }
      currFields.images.value = obj?.images || [];
      currFields.schedule.value = obj?.offerSchedule?.schedule || 'Instant';
      currFields.date.value = obj?.offerSchedule?.oneTimeSchedule?.date;
      currFields.oneTime.value = obj?.offerSchedule?.oneTimeSchedule?.time;
      currFields.days.value = [];
      currFields.everyday.value = obj?.offerSchedule?.repeatSchedule?.everyday
        ? 'EveryDay'
        : 'Custom';
      currFields.from.value = obj?.offerSchedule?.repeatSchedule?.from;
      currFields.to.value = obj?.offerSchedule?.repeatSchedule?.to;
      currFields.time.value = obj?.offerSchedule?.repeatSchedule?.time;
      currFields.impressions.value =
        obj?.offerSchedule?.schedule === 'Instant'
          ? ''
          : Number(obj?.offerSchedule?.impressionsDay) > 0
          ? Number(obj?.offerSchedule?.impressionsDay)
          : '';
      obj.offerSchedule.repeatSchedule.days.forEach((day) => {
        currFields.days[day.toLowerCase()] = true;
        currFields.days.value.push(day);
      });
      const initialHtml = obj?.message || '';
      setMessageHtml(initialHtml);
      setMsgCount(toPlainText(initialHtml).length);
      currFields.message.value = toPlainText(initialHtml);

      setFormData(currFields);
      const { Video: videoMediaContent, GIF: gifMediaContent } = decodeMediaKeyValue(
        obj?.mediaContent,
      );
      const videoData = videoMediaContent || obj?.videos || {};
      const gifData = gifMediaContent || obj?.gifs || {};
      setVideoImageUrl(videoData?.imageUrl || '');
      setGifImageUrl(gifData?.imageUrl || '');
      setRawVideos(renderVideos(videoData));
      setRawGifs(renderGifs(gifData));
    }
  }, [obj]);

  const onChangeResident = (e) => {
    const currField = { ...formData.recipient };
    currField.value = e.target.value;
    setFormData({ recipient: currField });
  };

  const onChangeDays = (e) => {
    const currField = { ...formData.everyday };
    currField.value = e.target.value;
    setFormData({ everyday: currField });
  };

  const handleTimePickerChange = (date, value, type) => {
    const currTimeField = { ...formData[type] };
    currTimeField.value = value;
    handleValidation(currTimeField);
    setFormData({
      [type]: currTimeField,
    });
  };

  const handleDatePickerChange = (date, value, type) => {
    const currDateField = { ...formData[type] };
    currDateField.value = value;
    handleValidation(currDateField);
    if (type === 'date' || type === 'from' || type === 'to') {
      const m = moment(value, 'DD-MM-YYYY', true);
      const isPast = m?.isValid() && m?.isBefore(moment()?.startOf('day'), 'day');
      if (!m.isValid() || isPast) {
        currDateField.errors = {
          ...currDateField?.errors,
          validDate: 'Invalid date',
        };
      } else {
        const { validDate, ...rest } = currDateField?.errors || {};
        currDateField.errors = rest;
      }
    }
    setFormData({ [type]: currDateField });
  };

  const setErrorText = (type) => {
    if (formData[type].errors.required) return formData[type].errors.required;
    if (type === 'from' || type === 'to' || type === 'date') {
      if (formData[type].errors.validDate) return formData[type].errors.validDate;
      if (type === 'to' && validateTillFromDate()) return VALID_DATE_ERROR_MESSAGE;
    } else {
      if (formData[type].errors.validTime) return formData[type].errors.validTime;
    }
    return null;
  };

  const validateTillFromDate = () => {
    if (!formData?.from?.value || !formData?.to?.value) return false;
    const start = moment(formData?.from?.value, 'DD-MM-YYYY', true);
    const end = moment(formData?.to.value, 'DD-MM-YYYY', true);
    if (!start?.isValid() || !end?.isValid()) return false;
    return end?.isBefore(start, 'day');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        dispatch(stepUpLoaderCount());
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        const payload = {};
        let residentFloorIds = [];
        let residentRoomTypeIds = [];
        for (let field in formData) {
          payload[field] = formData[field].value;
          if (field === 'residentFloor' || field === 'residentRoomType') {
            if (formData[field].value && formData[field].value.length > 0) {
              formData[field].value.forEach((item) => {
                if (field === 'residentFloor') {
                  residentFloorIds.push(originalFloorList.find((x) => x.name === item)?.id);
                }
                if (field === 'residentRoomType') {
                  residentRoomTypeIds.push(originalRoomTypeList.find((x) => x.name === item)?.id);
                }
              });
            }
          }
        }
        const isMobileDevice =
          Array.isArray(formData.devices.value) && formData.devices.value.includes('Mobile');
        payload.message = isMobileDevice
          ? toPlainText(messageHtml || '')
              ?.replace(/\n/g, ' ')
              ?.replace(/\s+/g, ' ')
              ?.trim()
          : (messageHtml || '')?.trim();
        payload.residentFloorIds = residentFloorIds;
        payload.residentRoomTypeIds = residentRoomTypeIds;
        payload.images = await getProcessedImages(
          rawImages,
          originalHotels.find((hotel) => hotel.id === hotelId).groupId,
          NOTIFICATION_CREATE,
          hotelId,
        );

        const gifData = await processGifsForUpload({
          rawGifs,
          groupId,
          propertyType: NOTIFICATION_CREATE,
          hotelId,
        });

        const mediaContent = toMediaContent({
          videoList: rawVideos,
          videoImageUrl,
          gifList: gifData,
          gifImageUrl,
        });
        payload.mediaContent = mediaContent;

        payload.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
        payload.timeOffset = new Date().getTimezoneOffset();
        payload.offerSchedule = {
          schedule: formData.schedule.value,
          impressionsDay: formData.schedule.value === 'Instant' ? 1 : formData.impressions.value,
          oneTimeSchedule:
            formData.schedule.value === 'One-time'
              ? {
                  date: formData.date.value,
                  time: formData.oneTime.value,
                }
              : null,
          repeatSchedule:
            formData.schedule.value === 'Repeat'
              ? {
                  from: formData.from.value,
                  to: formData.to.value,
                  everyday: formData.everyday.value === 'EveryDay' ? true : false,
                  days: formData.days.value.map((day) => day.toUpperCase()),
                  time: formData.time.value,
                }
              : null,
        };
        try {
          localStorage?.removeItem(draftKey);
        } catch {}

        toggleDrawer('', false, '');
        if (obj) {
          payload.id = obj.id;
          await updateNotifications(payload, hotelId, language);
          notificationManager('success', 'Notification updated successfully');
        } else {
          await createNotifications(payload, hotelId, language);
          notificationManager('success', 'Notification created successfully');
        }
        try {
          localStorage?.removeItem(draftKey);
        } catch {}
        dispatch(fetchAllNotifications(hotelId));
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          obj
            ? notificationManager('danger', 'Notification updation failed')
            : notificationManager('danger', 'Notification creation failed');
        }
        setLoading(false);
        setTabValue(0);
        resetMessageEditor();
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };
  const isFloorsMultiple = floorOptions?.length > 1;
  const isRoomTypeMultiple = roomTypeOptions?.length > 1;
  const isRoomMultiple = roomOptions?.length > 1;

  return (
    <div className='notification-create'>
      <div className='container pt-2 d-flex align-items-end flex-column'>
        <div className='row px-3 w-100 mt-4 align-items-center'>
          <div className='col-md-4'>
            <span className='page-title py-3'>
              {editing ? 'Edit Notification' : 'Add Notification'}
            </span>
          </div>
          <div className='col-md-6'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='roomTypes-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='Schedule' />
              <Tab label='Media' />
            </Tabs>
          </div>
          <div className='col-md-2 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          {tabValue === 0 && (
            <div className='row px-3 w-100 d-flex mt-3'>
              <h4 className='tab-title'>Details</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.type}
                    handleInputChange={(e) => {
                      setFormData({ type: e });
                    }}
                    labelField='name'
                    valueField='id'
                    options={NOTIFICATIONS_TYPE}
                    hideNullOption={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.title}
                    handleInputChange={(e) => {
                      setFormData({ title: e });
                    }}
                    maxLength={100}
                    endAdornment={true}
                    characterCount={true}
                    multiline={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <div className='rta-wrapper mb-1'>
                    <QuillToolbar />
                    <ReactQuill
                      key={editorKey}
                      ref={quillRef}
                      theme='snow'
                      value={messageHtml}
                      onChange={onQuillChange}
                      placeholder={`${formData.message.fieldName} *`}
                      modules={quillModules}
                      formats={quillFormats}
                      className={`rta-editor ${
                        formData.message?.errors?.required ? 'rta-error' : ''
                      }`}
                    />
                  </div>

                  <div className='rta-footer'>
                    <span className='rta-counter'>
                      {msgCount}/{MESSAGE_MAX}
                    </span>
                    <span style={{ marginLeft: '10px' }}>
                      {formData?.message?.errors?.required && (
                        <span className='rta-err-msg'>{formData?.message?.errors?.required}</span>
                      )}
                    </span>
                  </div>
                </div>
              </div>

              <div className='mt-4'>
                <div className='d-flex align-items-center'>
                  <h4 className='tab-title mb-0'>Devices</h4>
                  <Tooltip
                    title='Note: Text formatting styles will not be applied on mobile notifications and may affect other channels.'
                    placement='right'
                  >
                    <InfoIcon fontSize='small' className='ms-2' />
                  </Tooltip>
                </div>
                <div className='row'>
                  <div className='col-md-6 mb-3'>
                    <CustomMultiSelect
                      item={formData.devices}
                      options={NOTIFICATION_DEVICE}
                      hideNullOption={true}
                      handleInputChange={(e) => {
                        setFormData({ devices: e });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='mt-4'>
                <h4 className='tab-title'>Recipient</h4>
                <div className='custom-upload col-md-12 mt-3'>
                  <RadioGroup
                    row
                    aria-label={formData.recipient.fieldName}
                    onChange={(e) => {
                      onChangeResident(e);
                    }}
                    value={formData.recipient.value}
                    name={formData.recipient.fieldName}
                    className='document-type mb-3'
                  >
                    <FormControlLabel
                      value='Both'
                      control={<Radio color='primary' />}
                      label='Both'
                      className='me-5'
                    />
                    <FormControlLabel
                      value='Resident'
                      control={<Radio color='primary' />}
                      label='Resident'
                      className='me-5'
                    />
                    <FormControlLabel
                      value='Non-resident'
                      control={<Radio />}
                      label='Non-resident'
                    />
                  </RadioGroup>
                </div>
                {formData?.recipient?.value === 'Resident' && (
                  <div className='row'>
                    <div className='col-md-6 mb-3'>
                      <CustomMultiSelect
                        item={formData.residentFloor}
                        options={floorOptions}
                        valueField='name'
                        labelField='name'
                        hideNullOption={true}
                        handleInputChange={(e) => setFormData({ residentFloor: e })}
                        isSearchable
                        getSearchInput={onSearchFloorList}
                        searchValue={floorSearchValue}
                        searchPlaceholder='Search Floor(s)'
                        selectAllOption={isFloorsMultiple}
                        showHeaderActions
                      />
                    </div>
                    <div className='col-md-6 mb-3'>
                      <CustomMultiSelect
                        item={formData?.residentRoomType}
                        options={roomTypeOptions}
                        valueField='name'
                        labelField='name'
                        hideNullOption={true}
                        handleInputChange={(e) => setFormData({ residentRoomType: e })}
                        isSearchable
                        getSearchInput={onSearchRoomTypeList}
                        searchValue={roomTypeSearchValue}
                        searchPlaceholder='Search Roomtype(s)'
                        selectAllOption={isRoomTypeMultiple}
                        showHeaderActions
                      />
                    </div>
                    <div className='col-md-6 mb-3'>
                      <CustomMultiSelect
                        item={formData?.residentRoom}
                        options={roomOptions}
                        valueField='number'
                        labelField='number'
                        hideNullOption={true}
                        handleInputChange={(e) => setFormData({ residentRoom: e })}
                        isSearchable
                        getSearchInput={onSearchRoomList}
                        searchValue={roomSearchValue}
                        searchPlaceholder='Search Room(s)'
                        selectAllOption={isRoomMultiple}
                        showHeaderActions
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {tabValue === 1 && (
            <div className='row px-3 w-100 d-flex mt-3'>
              <h4 className='tab-title'>Schedule</h4>
              <div className='d-flex'>
                <div className='custom-upload col-md-12 mt-2'>
                  <div className='d-flex align-items-center'>
                    <RadioGroup
                      row
                      aria-label={formData.schedule.fieldName}
                      onChange={(e) => {
                        onChangeScheduleStatus(e);
                      }}
                      value={formData.schedule.value}
                      name={formData.schedule.fieldName}
                      className='mb-1'
                    >
                      <FormControlLabel
                        value='Instant'
                        control={<Radio color='primary' />}
                        label='Instant'
                        className='me-5'
                      />
                      <FormControlLabel
                        value='One-time'
                        control={<Radio color='primary' />}
                        label='One-time'
                        className='me-5'
                      />
                      <FormControlLabel
                        value='Repeat'
                        control={<Radio color='primary' />}
                        label='Repeat'
                        className='me-5'
                      />
                    </RadioGroup>

                    <Tooltip
                      title='Notifications will repeat for the period selected.'
                      placement='right'
                    >
                      <InfoIcon fontSize='small' className='mb-1' />
                    </Tooltip>
                  </div>
                </div>
              </div>

              {formData.schedule.value === 'One-time' && (
                <div className='row'>
                  <div className='col-md-6 mb-2'>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardDatePicker
                        variant='inline'
                        margin='normal'
                        id='Date'
                        label='Date'
                        minDate={new Date()}
                        className='col-md-12 mb-2'
                        format='DD-MM-YYYY'
                        required={formData.date.validations.includes('required')}
                        inputValue={formData.date.value}
                        onChange={(date, value) => handleDatePickerChange(date, value, 'date')}
                        error={
                          formData.date?.errors.required || formData.date?.errors.validDate
                            ? true
                            : false
                        }
                        helperText={setErrorText('date')}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className='col-md-6'>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <KeyboardTimePicker
                        variant='inline'
                        margin='normal'
                        id='onetime'
                        label='Time'
                        className='col-md-12 mb-2'
                        ampm={false}
                        format='HH:mm'
                        required={formData.oneTime.validations.includes('required')}
                        inputValue={formData.oneTime.value}
                        onChange={(date, value) => handleTimePickerChange(date, value, 'oneTime')}
                        error={formData.oneTime?.errors.validTime ? true : false}
                        helperText={setErrorText('oneTime')}
                        keyboardIcon={<WatchLaterIcon />}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              )}
              {formData.schedule.value === 'Repeat' && (
                <div>
                  <div className='row'>
                    <div className='col-md-6 mb-2'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          variant='inline'
                          margin='normal'
                          id='from'
                          label='From'
                          minDate={new Date()}
                          className='col-md-12 mb-2'
                          format='DD-MM-YYYY'
                          required={formData.from.validations.includes('required')}
                          inputValue={formData.from.value}
                          onChange={(date, value) => handleDatePickerChange(date, value, 'from')}
                          error={
                            formData.from?.errors.required || formData.from?.errors.validDate
                              ? true
                              : false
                          }
                          helperText={setErrorText('from')}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                    <div className='col-md-6'>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          variant='inline'
                          margin='normal'
                          id='to'
                          label='To'
                          minDate={new Date()}
                          className='col-md-12 mb-2'
                          format='DD-MM-YYYY'
                          required={formData.to.validations.includes('required')}
                          inputValue={formData.to.value}
                          onChange={(date, value) => handleDatePickerChange(date, value, 'to')}
                          error={
                            formData.to?.errors.required ||
                            formData.to?.errors.validDate ||
                            validateTillFromDate()
                              ? true
                              : false
                          }
                          helperText={setErrorText('to')}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>

                  <div className='custom-upload col-md-6 mt-3'>
                    <RadioGroup
                      row
                      aria-label={formData.everyday.fieldName}
                      onChange={(e) => {
                        onChangeDays(e);
                      }}
                      value={formData.everyday.value}
                      name={formData.everyday.fieldName}
                      className='mb-3'
                    >
                      <FormControlLabel
                        value='EveryDay'
                        control={<Radio color='primary' />}
                        label='Everyday'
                        className='me-5'
                      />
                      <FormControlLabel
                        value='Custom'
                        control={<Radio color='primary' />}
                        label='Custom'
                        className='ms-4'
                      />
                    </RadioGroup>
                  </div>
                  {formData.everyday.value === 'Custom' && (
                    <div>
                      <div className='d-flex justify-content-between mt-1 '>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.days.monday}
                              className='check-box'
                              onChange={(e) => onDaysCheckChange(e, 'monday')}
                              disabled={!allowedDays?.has('monday')}
                            />
                          }
                          label='Monday'
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.days.tuesday}
                              className='check-box'
                              onChange={(e) => onDaysCheckChange(e, 'tuesday')}
                              disabled={!allowedDays?.has('tuesday')}
                            />
                          }
                          label='Tuesday'
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.days.wednesday}
                              className='check-box'
                              onChange={(e) => onDaysCheckChange(e, 'wednesday')}
                              disabled={!allowedDays?.has('wednesday')}
                            />
                          }
                          label='Wednesday'
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.days.thursday}
                              className='check-box'
                              onChange={(e) => onDaysCheckChange(e, 'thursday')}
                              disabled={!allowedDays?.has('thursday')}
                            />
                          }
                          label='Thursday'
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.days.friday}
                              className='check-box'
                              onChange={(e) => onDaysCheckChange(e, 'friday')}
                              disabled={!allowedDays?.has('friday')}
                            />
                          }
                          label='Friday'
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.days.saturday}
                              className='check-box'
                              onChange={(e) => onDaysCheckChange(e, 'saturday')}
                              disabled={!allowedDays?.has('saturday')}
                            />
                          }
                          label='Saturday'
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.days.sunday}
                              className='check-box'
                              onChange={(e) => onDaysCheckChange(e, 'sunday')}
                              disabled={!allowedDays?.has('sunday')}
                            />
                          }
                          label='Sunday'
                        />
                      </div>
                    </div>
                  )}
                  {daysError && <p className='field-error'>Please select days</p>}
                </div>
              )}
              {formData.schedule.value !== 'Instant' && (
                <>
                  <div className='d-flex mt-5'>
                    <h4 className='tab-title '>Impressions</h4>
                    <Tooltip
                      title='For multiple impressions, interval between notification is set to 8hrs by default.'
                      placement='right'
                    >
                      <InfoIcon fontSize='small' className='align-self-center mb-2 ms-5' />
                    </Tooltip>
                  </div>
                  <div className='row'>
                    <div className='col-md-6 mb-3'>
                      <CustomTextField
                        item={formData?.impressions}
                        handleInputChange={(e) => {
                          let val = Number(e.value ?? e);
                          if (!val) {
                            e.value = '';
                          } else if (val > 3) {
                            e.value = 1;
                          }
                          setFormData({ impressions: e });
                        }}
                        type='number'
                        max={3}
                        min={1}
                        stripZeroOnSpinner
                        disableDot
                      />
                    </div>
                    {formData.schedule.value === 'Repeat' && (
                      <div className='col-md-6 mb-3 ps-3'>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                          <KeyboardTimePicker
                            variant='inline'
                            id='Time'
                            label='Time'
                            className='col-md-12'
                            ampm={false}
                            format='HH:mm'
                            required={formData.time.validations.includes('required')}
                            inputValue={formData.time.value}
                            onChange={(date, value) => handleTimePickerChange(date, value, 'time')}
                            error={
                              formData.time?.errors.required || formData.time?.errors.validTime
                                ? true
                                : false
                            }
                            helperText={setErrorText('time')}
                            keyboardIcon={<WatchLaterIcon />}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          )}
          {tabValue === 2 && (
            <div className='row px-3 w-100 d-flex mt-3'>
              <div className='col-md-12 mb-3'>
                <ImageUpload
                  uploadedImages={formData.images.value}
                  imgList={rawImages}
                  onImageListUpdated={onImageListUpdated}
                  onUploadedImageRemoval={onUploadedImageRemoval}
                  onImagesLoading={(status) => {
                    setLoading(status);
                  }}
                  videoImageUrl={videoImageUrl}
                  onVideoImageUrlChange={setVideoImageUrl}
                  gifImageUrl={gifImageUrl}
                  onGifImageUrlChange={setGifImageUrl}
                  videoList={rawVideos}
                  gifList={rawGifs}
                  onVideoListUpdated={setRawVideos}
                  onGifListUpdated={setRawGifs}
                  hotelId={hotelId}
                  groupId={groupId}
                  propertyType={NOTIFICATION_CREATE}
                  onVideoError={setHasVideoError}
                  onThumbnailUploading={setIsThumbnailUploading}
                  onVideoLoading={setIsVideoLoading}
                  onGifLoading={setIsGifLoading}
                />
              </div>
            </div>
          )}
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            {tabValue < 2 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={onNextClick}
                size='large'
                className='me-3'
                disabled={
                  isTabInValid ||
                  hasVideoError ||
                  isThumbnailUploading ||
                  isVideoLoading ||
                  isGifLoading
                }
              >
                Next
              </Button>
            ) : (
              <Button
                disabled={
                  loading || hasVideoError || isThumbnailUploading || isVideoLoading || isGifLoading
                }
                onClick={handleSubmit}
                variant='contained'
                color='primary'
                className='me-3'
                size='large'
              >
                {obj ? 'Update' : 'Add'}
              </Button>
            )}
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {loading && <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>}
        </div>
      </div>
    </div>
  );
};

export default NotificationCreate;
